import {
  createMutationStore,
  createQueryStore,
} from '@ferreri/minato-react-utils';
import { getTerm, getTermAgreement, postTermAgreement } from './terms.client';

export const useTerms = (slug: string) => {
  return createQueryStore({
    queryKey: ['terms', slug],
    queryFn: () => getTerm(slug),
    enabled: Boolean(slug),
  });
};

export const useTermAgreement = (slug: string) => {
  return createQueryStore({
    queryKey: ['term-agreement', slug],
    queryFn: () => getTermAgreement(slug),
    enabled: Boolean(slug),
  });
};

export const useUpdateTermAgreement = () => {
  return createMutationStore({
    mutationFn: postTermAgreement,
  });
};
